export default __webpack_public_path__ + "static/media/neil.bd188567.jpg";